module.exports = __webpack_public_path__ + "static/media/SQL-Certificate.561248fd.jpg";